import { Paper, Box, CircularProgress } from "@mui/material";
import React, { useRef, useEffect, useState } from 'react';
import moment from "moment";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Col, Row, Container } from "react-bootstrap"
import CircleIcon from '@mui/icons-material/Circle';
import * as EquipamentsServices from "../services/equipamentsService";
import * as getFeatures from "../services/featuresService";
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';


export default function CommunicationMap() {
    const date = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    };
    const equipamentMap = {
        clp_01: 12,
        clp_02: 9,
        smartlogger_01: 8,
        waether_station_01: 6,
        ncu_trackers_01: 7,
        energy_meter_01: 10,
        relay_01: 11,
        relay_02: 13,
        nobreak_01: 4,
        router: 2,
        internet: 5,
        scada: 3

    }

    const { usinaId } = useParams();
    const iframeRef = useRef(null);
    const [html, setHtmlContent] = useState()
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    async function getData() {
        const features = await getFeatures.getFeatures(usinaId);
        const trackerMapFeature = features.find(f => f.feature === "CommunicationMap");
        const trackerMapUrl = trackerMapFeature?.attachmentUrl;
        if (trackerMapUrl) {
            const response = await fetch(trackerMapUrl);
            const data = await response.text();
            setHtmlContent(data);
        }


        const equipamentStatus = await EquipamentsServices.getEquipamentsStatus(usinaId)

        processarResposta(convertEquipamentsStatusToFault(equipamentStatus))
    }

    async function updatePage() {
        return "string"
    }

    function convertEquipamentsStatusToFault(equipaments) {
        var result = []
        equipaments.forEach((equipament) => {
            const equipamentDate = moment.utc(equipament?.updated_at)
            const minutesDataDiff = moment.utc().diff(equipamentDate, 'minutes')

            //TODO: REMOVE THIS CONDITIONAL
            if (minutesDataDiff >= 20) {
                result.push(
                    { id: equipamentMap["router"] },
                    { id: equipamentMap["scada"] },
                    { id: equipamentMap["internet"] }
                )
            }

            if (!equipament.status || minutesDataDiff >= 20) {
                const equipamentKey = equipament.equipament.toString() + "_" + equipament.cod.toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false
                })
                result.push({ id: equipamentMap[equipamentKey] })
            }
        })
        return result
    }

    useEffect(() => {
        setLoading(true);

        getData()

        setLoading(false);

        let intervaloDTO = {
            startDate: "",
            endDate: "",
        };

        intervaloDTO.startDate = moment(
            new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0)
        ).format("YYYY-MM-DDTHH:mm");

        intervaloDTO.endDate = moment(
            new Date(date.year, date.month - 1, date.day, 23, 59, 59)
        ).format("YYYY-MM-DDTHH:mm");

        //processarResposta(equipamentsFaultArray)

        let counter = 0;
        dispatch({ type: "SET_COUNTER", value: counter });
        const intervalId = setInterval(() => {
            counter++;
            if (counter === 60) {
                updatePage();
                counter = 0;
            }
            dispatch({ type: "SET_COUNTER", value: counter });
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    // Função para processar a resposta e adicionar classes
    async function processarResposta(equipments) {
        equipments.forEach(equipment => {
            const elemento = document.getElementById(`id${equipment.id}`);
            if (elemento) {
                elemento.style.stroke = "red";
            }
        });
    }


    let CommunicationMap = (
        <>
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "75vh",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Paper
                        style={{ backgroundColor: "#0a5068", fontFamily: 'sans-serif', marginTop: '40px' }} elevation={3}
                    >
                        <Container>
                            <Row
                                className="mb-3 justify-content-center align-items-center"
                                style={{ fontFamily: 'Roboto' }}
                            >
                                <Col
                                    xs={12} md={6}
                                    className="pt-2 pb-sm-2 text-white d-flex flex-column align-items-start justify-content-center"
                                >
                                    <div className="d-flex align-items-center">
                                        <DnsRoundedIcon />
                                        <b style={{ fontSize: "20px", marginLeft: 8 }}>
                                            Monitoramento de Comunicação
                                        </b>
                                    </div>
                                </Col>
                                <Col
                                    xs={12} md={6}
                                    className="pt-2 pb-sm-2 d-flex flex-column align-items-end justify-content-center"

                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                                        <b className="text-white" >
                                            <CircleIcon sx={{ color: "green" }} /> Equipamento com comunicação
                                        </b>
                                        <b className="text-white">
                                            <CircleIcon sx={{ color: "red" }} /> Equipamento sem comunicação
                                        </b>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Paper>

                    <Paper
                        style={{ minHeight: "90vh", padding: "15px", backgroundColor: "#0a5068" }} elevation={3}
                    >
                        <Container className="d-flex justify-content-center">
                            <div
                                className="d-flex justify-content-center align-items-center text-center"

                                dangerouslySetInnerHTML={{ __html: html }}

                                style={{ width: "100%", fontFamily: 'Roboto' }}
                            />
                        </Container>
                    </Paper>
                </>
            )}
        </>
    )

    return CommunicationMap

}